/** Bounded ASCII reconstruction of FD11 00924330/00924780.
 * See docs/research/final-draft/pagination-native-findings.txt. Native CRT
 * locale classification and the surrounding physical fit engine remain open. */
const whitespace=(character:string)=>/^[ \t\r\n\v\f]$/.test(character);
export function isScriptSentenceEnd(text:string,index:number):boolean {
    if(!'.?!;'.includes(text[index]??'') || !text[index] || !whitespace(text[index+1]??''))return false;
    // The native suppression branch applies to all four punctuation marks.
    return !/(?:^|[ \t\r\n\v\f])(?:DR|MR|MS|MRS|ST|AVE|BLVD)$/i.test(text.slice(Math.max(0,index-5),index));
}

/** Opening sentence (or explicit line), including its following whitespace.
 * An unpunctuated paragraph is one candidate; the caller must bound its fit. */
export function firstScriptSentenceBoundary(text:string):number {
    for(let index=0;index<text.length;index++){
        if(text[index]!=='\r' && text[index]!=='\n' && !isScriptSentenceEnd(text,index))continue;
        let boundary=index+1;
        while(boundary<text.length && whitespace(text[boundary]))boundary++;
        return boundary;
    }
    return text.length;
}

/** Return a UTF-16 source boundary at or before the fitted range end. Explicit
 * CR/LF remains a boundary. Whitespace is owned by the preceding source range. */
export function lastScriptSentenceBoundary(text:string,start:number,end:number):number|undefined {
    for(let index=Math.min(end,text.length)-1;index>=start;index--){
        const newline=text[index]==='\r'||text[index]==='\n';
        if(!newline && !isScriptSentenceEnd(text,index))continue;
        let boundary=index+1;
        if(text[index]==='\r' && text[boundary]==='\n')boundary++;
        while(boundary<end && whitespace(text[boundary]))boundary++;
        if(boundary>start && boundary<=end)return boundary;
    }
}
